import Button from 'react-bootstrap/Button';

function ShowDaneStatusPublicView({dataItemstatus, itemObj, DaneTime} ) {

  const isPreviousDate = (dateString) => {
    const currentDate = new Date();
    const inputDate = new Date(dateString);

    return inputDate < currentDate;
  };

  //if(isPreviousDate(itemObj.date)) { return(<Button variant='secondary' size='sm' disabled ><strong>Completed</strong> </Button>) }
  if(isPreviousDate(itemObj.date)) { return(<span style={{fontSize:"14px",color:"#b3b3ff"}}>Completed</span>) }

  if(dataItemstatus=='true')  {
        // return (<Button size='sm' variant='info' disabled ><strong>Reserved</strong> </Button>)
        return (<span style={{fontWeight:"bold", fontSize:"14.5px", color:"#9999ff"}}>Reserved</span>)
    }
  else
    {
      //  return (<Button size='sm' variant='success' onClick={()=>{handleShow(itemObj,DaneTime)}}>
      //   <span style={{fontSize:"12px", verticalAlign:"baseline"}}>Reserve</span>
      //   </Button>)
       return (
        <span style={{fontWeight:"bold", fontSize:"14.5px", color:"#990033", cursor:"pointer", backgroundColor:"yellow"}}><u>Available</u></span>
        )
    }
}

export default ShowDaneStatusPublicView